module.exports = __webpack_public_path__ + "img/logo.c0317110.png";